import React, { useState } from "react";
import { api, formatApiError } from "../../lib/api";
import { Columns3, FileDown, Loader2 } from "lucide-react";
import { LUNAR_LAMELLA } from "../../lib/planner";
import { LamellaBox } from "./WerkPanel";

export function AnsichtPanel({ plan, layout, onChange, quoteId, sectionLayouts, project }) {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");
  const seg = layout.segments[0];
  const secList = sectionLayouts || [{ sec: plan, layout }];
  const multi = (project?.sections?.length || 1) > 1;

  const download = async () => {
    setBusy(true); setErr("");
    try {
      const sections = secList.map(({ sec, layout: lay }) => ({
        model: sec.model, height: sec.height, postHeight: sec.postHeight, postProfil: sec.posts.field.profil,
        lamella: { ...LUNAR_LAMELLA, ...(sec.werk?.lamella || {}) }, elements: lay.segments[0]?.elements || [], name: sec.name,
        project: multi ? `${sec.name}: ${sec.model} H ${sec.height} mm – Mauerpfeiler` : (quoteId ? undefined : `${sec.model} H ${sec.height} mm – Mauerpfeiler`),
      })).filter((s) => s.elements.length);
      const r = await api.post("/planner/werkzeichnung", {
        view: "ansicht", sections, model: plan.model, height: plan.height,
        project: quoteId ? undefined : (multi ? "Zaunplan Ansicht – mehrere Abschnitte" : `${plan.model} H ${plan.height} mm – Mauerpfeiler`),
      }, { responseType: "blob" });
      window.open(URL.createObjectURL(r.data), "_blank");
    } catch (e) {
      setErr(formatApiError(e.response?.data?.detail) || e.message);
    } finally { setBusy(false); }
  };

  return (
    <section className="border border-zinc-200 p-4 space-y-3" data-testid="ansicht-panel">
      <h2 className="text-sm font-semibold uppercase tracking-widest text-zinc-700 pb-2 border-b border-zinc-200 flex items-center gap-2"><Columns3 size={14}/> Ansicht / Mauerpfeiler</h2>
      <div className="grid grid-cols-3 gap-2 text-sm">
        {[["Pfeiler", layout.pfeilerCount, "ansicht-pfeiler-count"], ["Felder", layout.fieldCount, "ansicht-field-count"], ["Tore", layout.gates.length, "ansicht-gate-count"]].map(([l, v, t]) => (
          <div key={l} className="bg-zinc-50 border border-zinc-200 px-2.5 py-2"><div className="text-[10px] uppercase tracking-widest text-zinc-500">{l}</div><div className="font-mono text-zinc-900" data-testid={t}>{v}</div></div>
        ))}
      </div>
      <LamellaBox plan={plan} onChange={onChange} />
      <button onClick={download} disabled={busy || !secList.some((x) => x.layout.segments[0]?.elements?.length)} data-testid="ansicht-pdf-button"
              className="w-full border border-zinc-900 text-zinc-900 text-sm font-medium px-4 py-2.5 rounded-sm hover:bg-zinc-900 hover:text-white disabled:opacity-40 flex items-center justify-center gap-2">
        {busy ? <Loader2 size={14} className="animate-spin"/> : <FileDown size={14}/>} Werkzeichnung Ansicht PDF{multi ? " – alle Abschnitte" : ""} (A4 quer)
      </button>
      {err && <div className="text-xs text-red-600" data-testid="ansicht-error">{err}</div>}
      <p className="text-[11px] text-zinc-500">Bokocrt: Pfeiler, Sockel, Lamellen und Tore mit Koten. Alu-Pfosten (falls gewählt) mit Profil „{plan.posts.field.profil}“, Höhe {plan.postHeight} mm.</p>
    </section>
  );
}
